import type { SelectHTMLAttributes } from 'react';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/** Native Select mit Aurora-Styling (teilt die Input-Basisklasse). */
export function Select({ className, ...rest }: SelectProps) {
  return (
    <select
      className={['au-input', 'au-select', className ?? ''].filter(Boolean).join(' ')}
      {...rest}
    />
  );
}
